<template>
  <Panel header="Environment" :toggleable="true" :collapsed="true">
    <div class="fontSmall taLeft">
      <div class="p-mb-2">weather factors</div>
    </div>
  </Panel>
</template>
